import React from 'react';
import Icon, { ICON_NAME } from '../../../../../../components/Icon';
import { OP_STATUS } from '../../../../../../util/varibles/constants';
import { IActivityLog, IOperation, IOperations } from '../../../../../../util/varibles/interface';
import InvoiceRelatedSelector from '../../../InvoiceRelated/InvoiceRelatedSelector';

type TOperation = IOperation['operation'];
type TInvoice = NonNullable<TOperation['invoices']>[number];

interface IProps {
    operation: TOperation
    activityLog: IActivityLog[]
    operations: IOperations
    vesselId: string
    onChange(invoices: TInvoice[]): void
}

const Invoices: React.FC<IProps> = ({ operation, activityLog, operations, vesselId, onChange }) => {
    const selectedIds = new Set((operation.invoices || []).map(item => item.operation_id));
    const isEdit = (operation.invoices || []).every(invoice => {
        return operations[invoice.operation_id]?.operation.status !== OP_STATUS.FINISHED;
    });

    return <InvoiceRelatedSelector
        operation={operation}
        activityLog={activityLog}
        operations={operations}
        vesselId={vesselId}
        value={Array.from(selectedIds)}
        className='flex flex-wrap items-center gap-x-4 gap-y-2 text-[15px]'
        isEdit={isEdit}
        before={<div className='text-comment flex items-center gap-1'>
            <Icon icon={ICON_NAME.MULTIPLE_INVOICE} size={19} bg="colorSub" className="mt-[1px]" />
            <span>Invoice related:</span>
        </div>}
        showLinks
        onChange={(_, invoices) => onChange(invoices)}
    />;
};

export default Invoices;
